<template>
    <div id="language-select">
      <div class="select" tabindex="1">
        <input class="options-select" name="selectors" type="radio" id="opt1" :checked="$i18n.locale == 'de'">
        <label for="opt1" class="option" @click="setLanguage('de')">DE</label>
        <input class="options-select" name="selectors" type="radio" id="opt2" :checked="$i18n.locale == 'el'">
        <label for="opt2" class="option" @click="setLanguage('el')">EL</label>
        <input class="options-select" name="selectors" type="radio" id="opt3" :checked="$i18n.locale == 'en'">
        <label for="opt3" class="option" @click="setLanguage('en')">EN</label>
        <input class="options-select" name="selectors" type="radio" id="opt4" :checked="$i18n.locale == 'es'">
        <label for="opt4" class="option" @click="setLanguage('es')">ES</label>
        <input class="options-select" name="selectors" type="radio" id="opt5" :checked="$i18n.locale == 'fr'">
        <label for="opt5" class="option" @click="setLanguage('fr')">FR</label>
        <input class="options-select" name="selectors" type="radio" id="opt6" :checked="$i18n.locale == 'it'">
        <label for="opt6" class="option" @click="setLanguage('it')">IT</label>
        <input class="options-select" name="selectors" type="radio" id="opt7" :checked="$i18n.locale == 'nl'">
        <label for="opt7" class="option" @click="setLanguage('nl')">NL</label>
       <input class="options-select" name="selectors" type="radio" id="opt8" :checked="$i18n.locale == 'pl'">
        <label for="opt8" class="option" @click="setLanguage('pl')">PL</label>
        <input class="options-select" name="selectors" type="radio" id="opt9" :checked="$i18n.locale == 'pt'">
        <label for="opt9" class="option" @click="setLanguage('pt')">PT</label>
      </div>
    </div>
</template>

<script>
export default {
  name: 'LanguageSelect',
  data: () => {
    return {}
  },
  methods: {
    setLanguage (val) {
      this.$i18n.locale = val;
      this.$emit('language-changed', val);
    }
  },
  mounted () {
    let tLoc = navigator.language || navigator.userLanguage
    const firstLng = 'en'
    const secondLng = ['de', 'el', 'es', 'fr', 'it', 'nl', 'pl', 'pt']
    if (tLoc) {
      let tLocPrimary = tLoc.substring(0, 2)
      if (secondLng.includes(tLocPrimary)) {
        tLoc = tLocPrimary
      } else {
        tLoc = firstLng
      }
    }

    this.$i18n.locale = tLoc;
    this.$emit('language-changed', tLoc);
  }
}
</script>

<style lang="scss">
  #language-select {
    position: absolute;
    left: 1em;
    top: 1em;
    .select {
      display: flex;
      flex-direction: column;
      position: relative;
      width: 6ch;
      border: 1px solid white;
      cursor: pointer;
    }

    .option {
      padding: 0 2em 0 0.5em;
      min-height: 2.5em;
      display: flex;
      align-items: center;
      border-top: 1px solid white;
      position: absolute;
      width: 100%;
      pointer-events: none;
      order: 2;
      z-index: 1;
      box-sizing: border-box;
      overflow: hidden;
      white-space: nowrap;
      font-family: 'Open Sans', sans-serif;
      color: white;
      cursor: pointer;
    }

    .option:hover {
      color: #0095d4;
      background: white;
    }

    .select:focus .option {
      position: relative;
      pointer-events: all;
    }

    input {
      opacity: 0;
      position: absolute;
      left: -99999px;
    }

    input:checked + label {
      order: 1;
      z-index: 2;
      background: #13a7e5;
      border-top: none;
      position: relative;
    }

    input:checked + label::after {
      content: "";
      width: 0.6em;
      height: 0.3em;
      background-color: white;
      clip-path: polygon(100% 0%, 0 0%, 50% 100%);
      position: absolute;
      right: 0.5em;
      top: calc(50% - 0.15em);
      pointer-events: none;
      z-index: 3;
    }
  }
</style>
